
import React from 'react';
import { 
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
  ContextMenuSeparator
} from "@/components/ui/context-menu";
import { Heart, Plus } from 'lucide-react';

interface VideoContextMenuProps {
  children: React.ReactNode;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  onOpenPlaylistDialog: () => void;
}

const VideoContextMenu = ({ 
  children, 
  isFavorite, 
  onToggleFavorite, 
  onOpenPlaylistDialog 
}: VideoContextMenuProps) => {
  return (
    <ContextMenu>
      <ContextMenuTrigger>
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent className="w-56">
        <ContextMenuItem 
          className="flex items-center cursor-pointer"
          onClick={onToggleFavorite}
        >
          <Heart className={`mr-2 h-4 w-4 ${isFavorite ? 'fill-youtube-red text-youtube-red' : ''}`} />
          {isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
        </ContextMenuItem>
        <ContextMenuSeparator />
        <ContextMenuItem
          className="flex items-center cursor-pointer"
          onClick={onOpenPlaylistDialog}
        >
          <Plus className="mr-2 h-4 w-4" />
          Ajouter à une playlist
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
};

export default VideoContextMenu;
